module.exports = __webpack_public_path__ + "static/media/logo-neuvana-dark-x1.5f59ecfe.png";